var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"taxman_img"}),_c('h1',[_vm._v("WHT Calculator for Goods")]),_c('p',[_vm._v("Withholding Tax Calculator")]),_c('h3',[_vm._v("GST & Income Tax Withholding Calculator")])])])
}]

export { render, staticRenderFns }